import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Slider from "react-slick";
import { slider1, slider2, slider3, slider4, slider5 } from "../Constant/Index";
import { useEffect } from "react";
import AppService from "../services/appServices";
import ReUse from "../services/helpers/reUse";
import Slidecompocard from "./Slidecompocard";
import { useSelector } from "react-redux";

function Slidecompo() {
  const location = useLocation();

  const [apiData, setApiData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [allProducts, setAllProducts] = useState([]);
  const [loading2, setLoading2] = useState(false);

  //   useEffect(() => {
  //     const allpro = AppService.getAllProducts();
  //     ReUse.getApiData(allpro, setApiData, setLoading);
  //   }, []);
  const searchQuery = location?.state?.searchQuery || "";

  const productsFilterData = useSelector((state) => state.productsfilters);

  const {
    categoryId,
    subCategoryId,
    minPrice,
    maxPrice,
    showProducts,
    sortByOrder,
  } = productsFilterData ?? {};

  useEffect(() => {
    const getAllProducts = AppService.getAllProducts({
      name: searchQuery,
      categoryId,
      subCategoryId,
      minPrice,
      maxPrice,
      currentPage,
    });
    // console.log(allProducts, "huhuhuh");

    ReUse.getApiData(getAllProducts, setAllProducts, setLoading);
  }, [categoryId, subCategoryId, minPrice, maxPrice, currentPage]);

  var settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 3,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <>
      <section className="slide-sec">
        <div className="container">
          <div className="slide-head">
            <h4>just for you</h4>
            <h4>
              <Link to="/shop">view all</Link>
            </h4>
          </div>
          <div className="row">
            <div className="col-md-12">
              <Slider {...settings}>
                {/* {ReUse.mapItems(loading, apiData, Slidecompocard)} */}
                {ReUse.mapItems(
                  loading2,
                  allProducts?.data?.slice(0, showProducts),
                  Slidecompocard
                )}

                {/* <div>
                  <div className="slide-dv">
                    <figure>
                      <img className="img-fluid" alt="slid-1" src={slider1} />
                    </figure>
                    <div className="slide-text">
                      <p>Lorem Ipsum is simply </p>
                      <div className="slide-for-flex">
                        <h5>$567.89</h5>
                        <div className="slide-star">
                          <ul className="slide-star-ul">
                            <li>
                              {" "}
                              <i class="fa fa-star" aria-hidden="true" />
                            </li>
                            <li>
                              {" "}
                              <i class="fa fa-star" aria-hidden="true" />
                            </li>
                            <li>
                              {" "}
                              <i class="fa fa-star" aria-hidden="true" />
                            </li>
                            <li>
                              {" "}
                              <i class="fa fa-star" aria-hidden="true" />
                            </li>
                            <li>
                              {" "}
                              <i class="fa fa-star" aria-hidden="true" />
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> */}
                {/* <div>
                  <div className="slide-dv">
                    <figure>
                      <img className="img-fluid" alt="slid-1" src={slider2} />
                    </figure>
                    <div className="slide-text">
                      <p>Lorem Ipsum is simply </p>
                      <div className="slide-for-flex">
                        <h5>$567.89</h5>
                        <div className="slide-star">
                          <ul className="slide-star-ul">
                            <li>
                              {" "}
                              <i class="fa fa-star" aria-hidden="true" />
                            </li>
                            <li>
                              {" "}
                              <i class="fa fa-star" aria-hidden="true" />
                            </li>
                            <li>
                              {" "}
                              <i class="fa fa-star" aria-hidden="true" />
                            </li>
                            <li>
                              {" "}
                              <i class="fa fa-star" aria-hidden="true" />
                            </li>
                            <li>
                              {" "}
                              <i class="fa fa-star" aria-hidden="true" />
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="slide-dv">
                    <figure>
                      <img className="img-fluid" alt="slid-1" src={slider3} />
                    </figure>
                    <div className="slide-text">
                      <p>Lorem Ipsum is simply </p>
                      <div className="slide-for-flex">
                        <h5>$567.89</h5>
                        <div className="slide-star">
                          <ul className="slide-star-ul">
                            <li>
                              {" "}
                              <i class="fa fa-star" aria-hidden="true" />
                            </li>
                            <li>
                              {" "}
                              <i class="fa fa-star" aria-hidden="true" />
                            </li>
                            <li>
                              {" "}
                              <i class="fa fa-star" aria-hidden="true" />
                            </li>
                            <li>
                              {" "}
                              <i class="fa fa-star" aria-hidden="true" />
                            </li>
                            <li>
                              {" "}
                              <i class="fa fa-star" aria-hidden="true" />
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="slide-dv">
                    <figure>
                      <img className="img-fluid" alt="slid-1" src={slider4} />
                    </figure>
                    <div className="slide-text">
                      <p>Lorem Ipsum is simply </p>
                      <div className="slide-for-flex">
                        <h5>$567.89</h5>
                        <div className="slide-star">
                          <ul className="slide-star-ul">
                            <li>
                              {" "}
                              <i class="fa fa-star" aria-hidden="true" />
                            </li>
                            <li>
                              {" "}
                              <i class="fa fa-star" aria-hidden="true" />
                            </li>
                            <li>
                              {" "}
                              <i class="fa fa-star" aria-hidden="true" />
                            </li>
                            <li>
                              {" "}
                              <i class="fa fa-star" aria-hidden="true" />
                            </li>
                            <li>
                              {" "}
                              <i class="fa fa-star" aria-hidden="true" />
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="slide-dv">
                    <figure>
                      <img className="img-fluid" alt="slid-1" src={slider5} />
                    </figure>
                    <div className="slide-text">
                      <p>Lorem Ipsum is simply </p>
                      <div className="slide-for-flex">
                        <h5>$567.89</h5>
                        <div className="slide-star">
                          <ul className="slide-star-ul">
                            <li>
                              {" "}
                              <i class="fa fa-star" aria-hidden="true" />
                            </li>
                            <li>
                              {" "}
                              <i class="fa fa-star" aria-hidden="true" />
                            </li>
                            <li>
                              {" "}
                              <i class="fa fa-star" aria-hidden="true" />
                            </li>
                            <li>
                              {" "}
                              <i class="fa fa-star" aria-hidden="true" />
                            </li>
                            <li>
                              {" "}
                              <i class="fa fa-star" aria-hidden="true" />
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="slide-dv">
                    <figure>
                      <img className="img-fluid" alt="slid-1" src={slider1} />
                    </figure>
                    <div className="slide-text">
                      <p>Lorem Ipsum is simply </p>
                      <div className="slide-for-flex">
                        <h5>$567.89</h5>
                        <div className="slide-star">
                          <ul className="slide-star-ul">
                            <li>
                              {" "}
                              <i class="fa fa-star" aria-hidden="true" />
                            </li>
                            <li>
                              {" "}
                              <i class="fa fa-star" aria-hidden="true" />
                            </li>
                            <li>
                              {" "}
                              <i class="fa fa-star" aria-hidden="true" />
                            </li>
                            <li>
                              {" "}
                              <i class="fa fa-star" aria-hidden="true" />
                            </li>
                            <li>
                              {" "}
                              <i class="fa fa-star" aria-hidden="true" />
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> */}
              </Slider>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Slidecompo;
